import React, { FC } from "react";
import { TemplateType } from "@xapp/ovai-lib";
import { Select } from "@xapp/components";
import { CUSTOM_TYPE, ON_DEMAND_TEMPLATE, RADIO_TEMPLATE } from "constants/templates";

export interface AppTemplateTypeDropdownProps {
    value: TemplateType | string;
    disabled?: boolean;
    onChange?(newValue: string): void;
}

/*
 * Simple stateless component to select an Apps Template Type.
 */
export const AppTemplateTypeDropdown: FC<AppTemplateTypeDropdownProps> = props => {
    const templateTypes = [
        {
            label: "Radio",
            value: RADIO_TEMPLATE
        },
        {
            label: "On Demand (Podcast)",
            value: ON_DEMAND_TEMPLATE
        },
        {
            label: "Conversational Self-service for CCI",
            value: "OC_STUDIO_STARTER_TEMPLATE"
        },
        {
            label: "Custom",
            value: CUSTOM_TYPE
        }
    ];
    // If no onChange is passed, it is disabled
    const disabled = !props.onChange ? true : props.disabled;

    return (
        <Select
            label="Template Type"
            disabled={disabled}
            items={templateTypes}
            onChange={props.onChange}
            value={props.value}
        />
    );
};
